export const STORE_STATUS = {
  FAILED: 'failed',
  PENDING: 'pending',
  RESOLVED: 'resolved',
} as const;

export type StoreStatus = (typeof STORE_STATUS)[keyof typeof STORE_STATUS];
